import React, { useState } from 'react'
import { Form, Upload, Input, Row, Space, Card, Avatar, Divider } from 'antd'
import { beforeUpload } from '../../../utils'
import { ButtonUploadDiv } from '../../SignupBin/AddBin'
import AddIcon from '../../../assets/icons/Add_image.png'
import { LocationSignUp } from '../../../components/LocationSignUp'
import { ButtonEx } from '../../HeroLocations/index.style'
import { isEmpty, isNull } from 'lodash'
import { uploadService } from '../../../services/upload'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import { FormItem, ButtonSolid } from '../../../shared.style'
import { useDeepEffect } from '../../../utils/hooks'
import imageCompression from 'browser-image-compression'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'

const WarningLatLng = ({ visible, handleClose }) => {
  return (
    <Dialog
      open={visible}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">
        โปรดกรอกข้อมูลละติจูด ลองติจูด
      </DialogTitle>
      <DialogActions>
        <Button onClick={() => handleClose()} color="primary" autoFocus>
          ปิด
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const LocationBin = (props) => {
  const { visible, onCancel, locationItem, heroId, onOk } = props
  const [form] = Form.useForm()
  const [locations, setLocations] = useState([])
  const [binImage, setBinImage] = useState('')
  const [warning, setWarning] = useState(false)
  const [searchSelect, setSearchSelect] = useState('1')

  const heroConfig = {
    radius: 5000,
    locationCount: 1
  }

  useDeepEffect(() => {
    if (!isNull(locationItem)) {
      form.setFieldsValue({
        locationName: locationItem.name,
        circularBin: locationItem.image,
        address: locationItem.address,
        lat: locationItem.lat,
        lng: locationItem.lng
      })
      setBinImage(locationItem.image)
      setLocations((prevState) => {
        prevState.push({
          lat: locationItem.lat,
          lng: locationItem.lng,
          address: locationItem.address,
          radius: heroConfig.radius
        })
        return [...prevState]
      })
    }
  }, [locationItem])

  const cancel = () => {
    setLocations([])
    onCancel()
  }

  const handleSetLocations = async (location) => {
    await setLocations((prevState) => {
      prevState.splice(1, 0, location)
      return [...prevState]
    })
  }

  const handleSetDeleteLocations = async (id) => {
    await setLocations((prevState) => {
      prevState.splice(id, 1)
      return [...prevState]
    })

    await localStorage.removeItem('location-data')
  }

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e
    }
    return e && e.fileList
  }

  const handleChange = async (info) => {
    const formData = new FormData()
    if (!isEmpty(info.fileList)) {
      const options = {
        maxSizeMB: 0.8,
        // maxWidthOrHeight: 256,
        useWebWorker: true
      }
      const compressedFile = await imageCompression(info.file, options)
      formData.append('image', compressedFile)
      const data = await uploadService(formData)
      await setBinImage(data.url)
    }
  }

  const onClose = () => {
    onCancel()
  }

  const onChangeSearch = (value) => {
    setSearchSelect(value)
  }

  const onFinish = async (values) => {
    const location = locations[0]
    if (searchSelect === '2') {
      const data = {
        address: values.address,
        heroId: heroId,
        id: isNull(locationItem) ? 0 : locationItem.id,
        lat: values.lat,
        lng: values.lng,
        locationImage: binImage,
        locationName: values.locationName
      }

      onOk(data)
      setBinImage('')
      setLocations([])
      form.resetFields()
    } else {
      if (!isEmpty(locations)) {
        const data = {
          address: values.address,
          heroId: heroId,
          id: isNull(locationItem) ? 0 : locationItem.id,
          lat: values.lat || location.lat,
          lng: values.lng || location.lng,
          locationImage: binImage,
          locationName: values.locationName
        }
        onOk(data)
        setBinImage('')
        setLocations([])
        form.resetFields()
      } else {
        setWarning(true)
      }
    }
  }

  return (
    <Dialog open={visible} onClose={onClose} maxWidth="md" fullWidth={true}>
      <DialogTitle style={{ backgroundColor: '#6ebf4b' }}>
        <span style={{ color: 'white' }}>เพิ่มสถานที่</span>
      </DialogTitle>
      <Card>
        <WarningLatLng
          visible={warning}
          handleClose={() => setWarning(false)}
        />
        <Form form={form} onFinish={onFinish} labelCol={{ span: 6 }}>
          <FormItem
            name="circularBin"
            rules={[
              {
                required: true,
                message: 'เลือกรูปภาพ Circular Bin'
              }
            ]}
            label="รูปภาพสถานที่ตั้ง หรือจุดวาง Circular Bin"
            getValueFromEvent={normFile}>
            <Upload
              name="circularBinImg"
              listType="picture"
              showUploadList={false}
              beforeUpload={beforeUpload}
              onChange={handleChange}>
              {binImage ? (
                <Avatar src={binImage} size={128} />
              ) : (
                <ButtonUploadDiv>
                  <img src={AddIcon} alt="" width={128} height={128} />
                </ButtonUploadDiv>
              )}
            </Upload>
          </FormItem>
          <Form.Item
            name="locationName"
            label="ชื่อสถานที่ตั้ง Circular Bin"
            rules={[
              {
                required: true,
                message: 'กรอกชื่อสถานที่'
              }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item name="address" label="ที่อยู่">
            <Input.TextArea autoSize={{ minRows: 2 }} />
          </Form.Item>
          <Divider style={{ margin: '12px 0' }} />
          <Space style={{ marginBottom: 10 }}>
            <ButtonSolid
              active={searchSelect === '1'}
              onClick={() => onChangeSearch('1')}>
              ค้นหาจากแผนที่
            </ButtonSolid>
            <ButtonSolid
              active={searchSelect === '2'}
              onClick={() => onChangeSearch('2')}>
              ค้นหาจากละติจูด ลองติจูด
            </ButtonSolid>
          </Space>
          {searchSelect === '1' && (
            <LocationSignUp
              locations={locations}
              heroConfig={heroConfig}
              handleSetLocations={handleSetLocations}
              handleSetDeleteLocations={handleSetDeleteLocations}
            />
          )}
          {searchSelect === '2' && (
            <div>
              <Form.Item
                name="lat"
                label="ละติจูด"
                rules={[
                  {
                    required: true,
                    message: 'กรอกละติจูด'
                  }
                ]}>
                <Input />
              </Form.Item>
              <Form.Item
                name="lng"
                label="ชื่อลองติจูด"
                rules={[
                  {
                    required: true,
                    message: 'กรอกลองติจูด'
                  }
                ]}>
                <Input />
              </Form.Item>
            </div>
          )}
          <Row justify="center" style={{ marginTop: 15 }}>
            <Space>
              <ButtonEx onClick={() => cancel()}>ยกเลิก</ButtonEx>
              <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
                บันทึก
              </ButtonEx>
            </Space>
          </Row>
        </Form>
      </Card>
    </Dialog>
  )
}

export default LocationBin



// WEBPACK FOOTER //
// ./src/pages/AccountLocationBin/LocationBin/index.js